import { localFormatDuration } from '@lmt/expressions';
import {
  getFactor,
  roundUsingFormat,
} from '@lmt/expressions/src/expressions/helpers/date-helper';
import { DataType } from '@lmt/shared-types';
import { localFormat } from '@lmt/unicorn-shared/app/helpers/date-helper';
import { addMilliseconds, parseISO, startOfToday } from 'date-fns';
import { assertNever } from '../../helpers/assert-never';
import { UIEditorDataObjectValue } from './UIEditorTypes';

export const TimeWithSecondsFormat = 'pp';

export function convertStringToTime(inputValue: string, format: string) {
  if (inputValue === '') return 0;
  const value = parseInt(inputValue);
  if (isNaN(value)) return null;

  try {
    const factor = getFactor(format);

    return factor * 1000 * value;
    if (format) return value || 0;
  } catch (e) {
    return null;
  }
}

/*
 Returns the string that should be displayed for the value in read-only view
  */
export function fieldValueToDisplayString(
  fieldDataType: DataType,
  fieldValue: UIEditorDataObjectValue,
  numberFormat: string,
): string {
  const defaultValue = '';
  if (fieldValue === undefined || fieldValue === null || fieldValue === '')
    return defaultValue;
  switch (fieldDataType) {
    case DataType.TimeOnly:
      const parsedIntValue = parseInt(fieldValue as string);
      if (isNaN(parsedIntValue)) {
        return defaultValue;
      } else if (numberFormat) {
        return localFormatDuration(parsedIntValue, numberFormat);
      } else {
        const date = addMilliseconds(startOfToday(), parsedIntValue);
        return localFormat(date, 'p');
        //const date = new Date(parsedIntValue);
        //return differenceInHours(date, new Date(0)) + localFormat(date, ':mm');
      }

    case DataType.DateOnly:
      return localFormat(
        (fieldValue as any) instanceof Date
          ? (fieldValue as unknown as Date)
          : new Date(fieldValue as string),
        numberFormat || 'P',
      );

    case DataType.DateTime:
      return localFormat(
        (fieldValue as any) instanceof Date
          ? (fieldValue as unknown as Date)
          : new Date(fieldValue as string),
        numberFormat || 'Pp',
      );

    case DataType.Number:
      if (numberFormat) {
        return roundUsingFormat(fieldValue as string, numberFormat);
      } else {
        return fieldValue as string;
      }

    case DataType.Text:
    case DataType.MultilineText:
      return fieldValue !== '' ? (fieldValue as string) : '-';

    case DataType.Boolean:
    // boolean is displayed as checkbox (handled in the function above)
    case DataType.Table:
    // Table is displayed as it should (handled in the function above)
    case DataType.Dictionary:
    // Dictionary values are handled in DictionaryInput component
    case DataType.Undefined:
      return '';

    default:
      assertNever(fieldDataType);
  }
}
